import poApi from "../api/poApi";
import { getCurrentAuthUser } from "./authorization";


const findPo = async (poId, callbackWithRemoteResult = ()=>{}) =>{
  const poFromStorage = getPoFromLocalStorage(poId);
  const poFromNetsuitePromise = getPoFromCm(poId);

  if(!poFromStorage){
    const poFromNetsuite = await poFromNetsuitePromise;
    addPoToLocalStorage(poId,poFromNetsuite);
    return poFromNetsuite;
  }
  poFromNetsuitePromise.then((result)=>{
    addPoToLocalStorage(poId,result);
    callbackWithRemoteResult(result);
  });

  return poFromStorage;
}

const getPoFromLocalStorage = (poId) => {
  let detailedPos = JSON.parse(localStorage.getItem("detailedPos"));
  if (!detailedPos) detailedPos = {};

  if (poId in detailedPos) {
    const now = new Date();
    if (now.getTime() > detailedPos[poId].expiry) {
      return null;
    }
    return detailedPos[poId].value;
  }
  return null;
};

const addPoToLocalStorage = (poId, poObject, ttl = 24 * 60 * 60 * 100) => { //24h ttl by default
  let detailedPos = JSON.parse(localStorage.getItem("detailedPos"));
  if (!detailedPos) detailedPos = {};

  const now = new Date();

  const item = {
    value: poObject,
    expiry: now.getTime() + ttl,
  };

  detailedPos[poId] = item;

  localStorage.setItem("detailedPos", JSON.stringify(detailedPos));
};

const getPoFromCm = async (poId) => {
  var authInfo = await getCurrentAuthUser();
  return poApi
    .getOpenPoOnCm(authInfo.plant.netsuiteCmId, poId)
    .then((result) => {
      if (result.data.status === "success") {
        return result.data.data.pos[0];
      } else alert("Error");
      return undefined;
    });
};

export default findPo;